export const AUTH_USER = "AUTH_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const AUTH_ERROR = "AUTH_ERROR";
export const FETCH_POST = "FETCH_POST";
export const ADD_POST = "ADD_POST";
export const POST_SHOW = "POST_SHOW";
export const DELETE_POST = "DELETE_POST";
export const EDIT_POST = "EDIT_POST";
export const UPDATE_POST = "UPDATE_POST";
export const FETCH_USER = "FETCH_USER";
export const FETCH_PEOPLE = "FETCH_PEOPLE";
export const FETCH_UPLOADS = "FETCH_UPLOADS";
export const ADD_IMGS = "ADD_IMGS";
export const FETCH_IMGS = "FETCH_IMGS";
export const FETCH_ADS = "FETCH_ADS";
export const FETCH_PROMO_ADS = "FETCH_PROMO_ADS";
export const FETCH_SEARCH = "FETCH_SEARCH";
export const FETCH_TRENDS = "FETCH_TRENDS";
export const FETCH_LEADS = "FETCH_LEADS";
export const CLEAR_STATE = "CLEAR_STATE";
export const MYCART_PLACEORDER = "MYCART_PLACEORDER";
export const FETCH_RZP_KEYS = "FETCH_RZP_KEYS";
export const FETCH_RECENT = "FETCH_RZP_RECENT";
export const FETCH_PRODUCT_TABS = "FETCH_PRODUCT_TABS";
export const FETCH_PRODUCT_DESC = "FETCH_PRODUCT_DESC";
export const FETCH_USER_ADDR = "FETCH_USER_ADDR";


/** WEBPACK FOOTER **
 ** ./src/actions/types.js
 **/